import * as React from 'react';
import * as Redux from 'react-redux';
import { allCiudadesAction } from '../CiudadesAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { ALL_CIUDADES } from '../CiudadesReducer';
import { FormHelperText } from '@mui/material';
import { validMessage } from '../../../../constants/ValidsFormConst';

const SelectFieldCiudadesComponent = ({
  idEstado,
  onChange,
  hasError,
  value,
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const ciudadesStore = Redux.useSelector((state) => state.ciudades);

  React.useEffect(() => {
    const fetchData = async () => {
      dispatch({
        type: ALL_CIUDADES,
        payload: { data: [] },
      });
      await allCiudadesAction(dispatch, idEstado);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEstado]);

  const select = (
    <FormControl fullWidth size="small" required error={hasError}>
      <InputLabel id={`label_${CONST.ciudad.name}`}>
        {CONST.ciudad.label}
      </InputLabel>
      <Select
        id={CONST.ciudad.name}
        value={value}
        labelId={`label_${CONST.ciudad.name}`}
        label={CONST.ciudad.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {ciudadesStore.all.map((el, index) => {
          return (
            <MenuItem key={`ciudad-${index}`} value={el.id}>
              {el.ciudad}
            </MenuItem>
          );
        })}
      </Select>
      {hasError && <FormHelperText>{validMessage.required}</FormHelperText>}
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-ciudades"
      opt={ciudadesStore.all}
      type={CONST.ciudad.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l="Ciudades"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldCiudadesComponent;
